<div class="icon-button-list">
  @if (isAllowedShape(drawingTypes.POINT)) {
    <button [class.button--active]="activeTool === 'POINT'"
          i18n-tmTooltip="@@core.draw.draw-point"
          tmTooltip="Draw point"
          mat-stroked-button
          color="primary"
          (click)="draw(drawingTypes.POINT)"><mat-icon svgIcon="tools_draw_point"></mat-icon></button>
  }
  @if (isAllowedShape(drawingTypes.LINE)) {
    <button [class.button--active]="activeTool === 'LINE'"
          i18n-tmTooltip="@@core.draw.draw-line"
          tmTooltip="Draw line"
          mat-stroked-button
          color="primary"
          (click)="draw(drawingTypes.LINE)"><mat-icon svgIcon="tools_draw_line"></mat-icon></button>
  }
  @if (isAllowedShape(drawingTypes.POLYGON)) {
    <button [class.button--active]="activeTool === 'POLYGON'"
          i18n-tmTooltip="@@core.draw.draw-polygon"
          tmTooltip="Draw polygon"
          mat-stroked-button
          color="primary"
          (click)="draw(drawingTypes.POLYGON)"><mat-icon svgIcon="tools_draw_polygon"></mat-icon></button>
  }
  @if (isAllowedShape(drawingTypes.SQUARE)) {
    <button [class.button--active]="activeTool === 'SQUARE'"
          i18n-tmTooltip="@@core.draw.draw-square"
          tmTooltip="Draw square"
          mat-stroked-button
          color="primary"
          (click)="draw(drawingTypes.SQUARE)"><mat-icon svgIcon="tools_draw_square"></mat-icon></button>
  }
  @if (isAllowedShape(drawingTypes.RECTANGLE)) {
    <button [class.button--active]="activeTool === 'RECTANGLE'"
          i18n-tmTooltip="@@core.draw.draw-rectangle"
          tmTooltip="Draw rectangle"
          mat-stroked-button
          color="primary"
          (click)="draw(drawingTypes.RECTANGLE)"><mat-icon svgIcon="tools_draw_rectangle"></mat-icon></button>
  }
  @if (isAllowedShape(drawingTypes.CIRCLE)) {
    <button [class.button--active]="activeTool === 'CIRCLE'"
          i18n-tmTooltip="@@core.draw.draw-circle"
          tmTooltip="Draw circle"
          mat-stroked-button
          color="primary"
          (click)="draw(drawingTypes.CIRCLE)"><mat-icon svgIcon="tools_draw_circle"></mat-icon></button>
  }
  @if (isAllowedShape(drawingTypes.ELLIPSE)) {
    <button [class.button--active]="activeTool === 'ELLIPSE'"
          i18n-tmTooltip="@@core.draw.draw-ellipse"
          tmTooltip="Draw ellipse"
          mat-stroked-button
          color="primary"
          (click)="draw(drawingTypes.ELLIPSE)"><mat-icon svgIcon="tools_draw_ellipse"></mat-icon></button>
  }
  @if (isAllowedShape(drawingTypes.STAR)) {
    <button [class.button--active]="activeTool === 'STAR'"
          i18n-tmTooltip="@@core.draw.draw-star"
          tmTooltip="Draw star"
          mat-stroked-button
          color="primary"
          (click)="draw(drawingTypes.STAR)"><mat-icon svgIcon="tools_draw_star"></mat-icon></button>
  }
  @if (isAllowedShape(drawingTypes.LABEL)) {
    <button [class.button--active]="activeTool === 'LABEL'"
          i18n-tmTooltip="@@core.draw.draw-label"
          tmTooltip="Draw label"
          mat-stroked-button
          color="primary"
          (click)="draw(drawingTypes.LABEL)"><mat-icon svgIcon="tools_draw_label"></mat-icon></button>
  }
  @if (allowRemoveSelectedFeature && selectedFeature) {
    <button i18n-tmTooltip="@@core.draw.delete-selected-feature"
          tmTooltip="Delete selected feature"
          mat-stroked-button
          color="warn"
          (click)="removeSelectedFeature()"><mat-icon svgIcon="remove"></mat-icon></button>
  }
</div>
@if (allowModify && showSelectButton) {
  <div class="icon-button-list">
    <button [class.button--active]="!activeTool"
            i18n-tmTooltip="@@core.draw.select-modify-move-feature"
            tmTooltip="Select, modify size and/or move feature"
            mat-stroked-button
            color="primary"
            (click)="enableSelectAndModify()"><mat-icon svgIcon="tools_cursor"></mat-icon></button>
  </div>
}
